import React from "react";

export function replaceNewlinesWithBr(text: string) {
  return text.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index !== text.split("\n").length - 1 && <br />}
    </React.Fragment>
  ));
}
